<template>
    <div>
        <ul :class="['tabs', tabFixed ? 'fixed' : '']" :style="'width:'+width">
            <li
                v-for="(item, index) in tabList"
                :key="item.desc"
                :class="active === index ? 'active' : ''"
                @click="onTab(index, item.desc)"
            >
                {{ item.title }}
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    props: {
        tabList: Array,
        tabsTop:Number,
        width:String
    },
    data() {
        return {
            active: 0,
            tabFixed: false,
            // tabsTop: 741,//741
        }
    },
    mounted() {
        window.addEventListener('scroll', this.watchScroll, true)

    },
    methods: {
        onTab(index, desc) {
            this.active = index
            this.$emit('onActive', desc)
        },
        // tabs吸顶
        watchScroll() {
            let scrollTop = document.documentElement.srollTop || window.pageYOffset || document.body.srollTop
            scrollTop > this.tabsTop ? this.tabFixed = true : this.tabFixed = false;
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.watchScroll,true);
    },

}
</script>

<style lang="scss" scoped>
@mixin clear {
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
}
.tabs {
    // width: 100%;
    width: 813px;
    height: 38px;
    // margin-top: 20px;
    border-bottom: 1px solid #ff9000;
    background: #f7f7f7;
    li {
        float: left;
        line-height: 38px;
        margin-right: 20px;
        padding: 0 10px;
        color: #666;
        @include clear;
        &:hover {
            cursor: pointer;
            // color: #FF9000;
        }
    }
    .active {
        background: #ff9000;
        color: #fff;
    }
}
.fixed {
    position: fixed;
    top: 0;
    left: auto;
}
</style>